<div *ngIf="imgSrc">
  <img [src]="imgSrc" alt="Vote option image"/>
</div>
<div [innerHTML]="option.content"></div>